import {React, useState} from 'react'
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import { useNotify, useTranslate } from 'react-admin';
import {TextField, Select,MenuItem,Dialog,DialogTitle,DialogContent} from '@mui/material'
import LoadingButton from '@mui/lab/LoadingButton'
import { notificationServices } from 'src/services/sales/notification/notification.service';
import CloseIcon from '@mui/icons-material/Close';
import { NotificationForm } from '../logic/NotificationForm';

export const GeneralSearch = () => {
    const notify = useNotify()
    const [field, setField] = useState("description")
    const [search, setSearch] = useState('')
    const [notifications, setNotifications] = useState([])
    const [loadingSearch, setLoadingSearch] = useState(false)
    const [openNotificationDialog, setOpenNotificationDialog] = useState(false)
    const [selectedNotification, setSelectedNotification] = useState(null)
    const [mode, setMode] = useState('show')
    const translate = useTranslate()
    const onSearch = () =>{
        setLoadingSearch(true)
        notificationServices.generalSearch(field, search).then((res)=>{
            if(res.data.issues){
                setNotifications(res.data.issues)
            } else {
                setNotifications([res.data.issue])
            }
                
        }).finally(()=>{
            setLoadingSearch(false)
        }).catch(()=>{
            notify('ra.message.notification_not_found',{type:'error'})
        })
    }
    const onSelect = (current_mode) =>{
        setMode(current_mode)
        setOpenNotificationDialog(true)
    }
  return (
    <div style={{display:'flex', flexDirection:'column'}}>
        <FormLabel id="search-for">{translate('ra.field.search_by')}</FormLabel>
        <RadioGroup
            defaultValue="description"
            value={field}
            onChange={(value)=>{setField(value.target.value)}}
            name="radio-buttons-group"
            sx={{flexDirection:'row'}}
        >
            <FormControlLabel value="description" control={<Radio />} label={translate('ra.field.description')} />
            <FormControlLabel value="subject" control={<Radio />} label={translate('ra.field.subject')} />
            <FormControlLabel value="issueID" control={<Radio />} label={'Id'} />
        </RadioGroup>
        <TextField 
            value={search}
            size='small'
            onChange={(value)=>{setSearch(value.target.value)}} 
        />
        {notifications?.length > 0 && <Select
            fullWidth
            style={{marginTop:'15px'}}
            size='small'
            onChange={(value)=>{setSelectedNotification(value.target.value)}}
            defaultValue={''}
            renderValue={(value)=> {
                if(value){
                    const foundNotification = notifications.find(noti=>noti.id === value);
                    if(foundNotification){
                        return (foundNotification.id + ' ' + foundNotification.subject)
                    }
                }
                return ''
                
            }}
        >
            {
                notifications.map((noti)=>(
                    <MenuItem key={noti.id} value={noti.id}>
                        {noti.id + ' ' + noti.subject}
                    </MenuItem>
                ))
                
            }
        </Select>}
        <div style={{display:'flex', flexDirection:'row',justifyContent:selectedNotification?'space-evenly':'flex-end'}}>
        {selectedNotification &&
        <>
            <LoadingButton 
            style={{alignSelf:'flex-end', marginTop:'15px', marginRight:'15px'}} 
            onClick={()=>onSelect('show')} 
            loading={loadingSearch}
            variant='contained'
            >
                {translate('ra.action.show')}
            </LoadingButton> 
            <LoadingButton 
                style={{alignSelf:'flex-end', marginTop:'15px', marginRight:'15px'}} 
                onClick={()=>onSelect('edit')} 
                loading={loadingSearch}
                variant='contained'
            >
                {translate('ra.action.edit')}
            </LoadingButton> 
            <LoadingButton 
                style={{alignSelf:'flex-end', marginTop:'15px', marginRight:'15px'}} 
                onClick={()=>onSelect('reply')} 
                loading={loadingSearch}
                variant='contained'
            >
                {translate('ra.action.reply')}
            </LoadingButton> 
        </>
        }
        <LoadingButton 
            style={{ marginTop:'15px'}} 
            onClick={onSearch} 
            loading={loadingSearch}
            variant='contained'
        >
            {translate('ra.action.search')}
        </LoadingButton>
        </div>
        <Dialog open={openNotificationDialog}  fullWidth maxWidth='lg' onClose={()=>{setOpenNotificationDialog(false)}}>
                <DialogTitle style={{display:'flex', flexDirection:'row', width:'100%', justifyContent:'space-between'}}>{translate('ra.field.notification')}
                  <CloseIcon style={{cursor:'pointer'}} onClick={()=>{setOpenNotificationDialog(false)}}/>
                </DialogTitle>
                <DialogContent>
                    <NotificationForm setDialogOpen={setOpenNotificationDialog} notificationId={selectedNotification} mode={mode}/>
                </DialogContent>
        </Dialog>
    </div>
  )
}
